import { defineComponent as l, computed as m, createBlock as p, openBlock as d, resolveDynamicComponent as f, mergeProps as u, unref as o, withCtx as c, renderSlot as h } from "vue";
import s from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Title/title.js";
import { useOUIAProps as z } from "../helpers/ouia.js";
const y = /* @__PURE__ */ l({
  name: "PfTitle",
  __name: "Title",
  props: {
    size: {},
    h: { default: 1 },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(r) {
    const t = {
      1: "2xl",
      2: "xl",
      3: "lg",
      4: "md",
      5: "md",
      6: "md"
    }, i = r, a = z({ id: i.ouiaId, safe: i.ouiaSafe }), n = m(() => t[Number(i.h)]);
    return (e, S) => (d(), p(f(`h${e.h}`), u(o(a), {
      class: [o(s).title, e.size && e.size in o(s).modifiers ? o(s).modifiers[e.size] : o(s).modifiers[n.value]]
    }), {
      default: c(() => [
        h(e.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
export {
  y as default
};
